export const catLinks = [
  {
    id: 1,
    url: "/video",
    name: "امت‌ ویدیو",
    text: "تمام ویدیوها",
    subcatLinks: [
      {
        id: 1,
        category: "video",
        url: "/video/ummatcapacity",
        text: "ظرفیت های امت اسلامی",
      },
      {
        id: 2,
        category: "video",
        url: "/video/didyouknow",
        text: "آیا میدانستید؟",
      },
      {
        id: 3,
        category: "video",
        url: "/video/campaigns",
        text: "کمپاین ها",
      },
      {
        id: 4,
        category: "video",
        url: "/video/various",
        text: "ویدیو های متفرقه",
      },
    ],
  },

  {
    id: 2,
    url: "/audio",
    name: "امت‌ آدیو",
    text: "تمام صوتی ها",
    subcatLinks: [
      {
        id: 1,
        category: "audio",
        url: "/audio/positionofht",
        text: "موقف حزب التحریر",
      },
      {
        id: 2,
        category: "audio",
        url: "/audio/towardslight",
        text: "بسوی روشنایی",
      },
      {
        id: 3,
        category: "audio",
        url: "/audio/tafsir",
        text: "سلسله درسهای تفسیر",
      },
      {
        id: 4,
        category: "audio",
        url: "/audio/qandawithamir",
        text: "پرسش و پاسخ با امیر حزب التحریر",
      },
      {
        id: 5,
        category: "audio",
        url: "/audio/sirat",
        text: "بخش سیرت",
      },
    ],
  },

  {
    id: 3,
    url: "/magazine",
    name: "امت‌ مجله",
    text: "تمام مجلات",
    subcatLinks: [
      {
        id: 1,
        category: "magazine",
        url: "/magazine/khilafahmagazine",
        text: "مجله خلافت",
      },
      {
        id: 2,
        category: "magazine",
        url: "/magazine/qeyam",
        text: "رساله قیام",
      },
      {
        id: 3,
        category: "magazine",
        url: "/magazine/taghir",
        text: "رساله تغییر",
      },
      {
        id: 4,
        category: "magazine",
        url: "/magazine/khilafahgahnama",
        text: "گاهنامه خلافت",
      },
      {
        id: 5,
        category: "magazine",
        url: "/magazine/ummat",
        text: "مجله امت",
      },
      {
        id: 6,
        category: "magazine",
        url: "/magazine/bookletandbrochure",
        text: "بوکلت و بروشور",
      },
    ],
  },

  {
    id: 4,
    url: "/news",
    name: "امت‌ نیوز",
    text: "تمام اخبار",
    subcatLinks: [
      {
        id: 1,
        category: "news",
        url: "/news/articles",
        text: "مقالات",
      },
      {
        id: 2,
        category: "news",
        url: "/news/infographic",
        text: "انفوگرافیک",
      },
      {
        id: 3,
        category: "news",
        url: "/news/videos",
        text: "ویدیو ها",
      },
    ],
  },
  {
    id: 5,
    url: "/book",
    name: "امت‌ کتاب",
    text: "تمام کتاب ها",
    subcatLinks: [
      {
        id: 1,
        category: "book",
        url: "/book/governance",
        text: "دولت داری",
      },
      {
        id: 2,
        category: "book",
        url: "/book/htprogram",
        text: "برنامه حزبی",
      },
      {
        id: 3,
        category: "book",
        url: "/book/globalactivity",
        text: "فعالیت های جهانی",
      },
      {
        id: 4,
        category: "book",
        url: "/book/interactingwithummat",
        text: "تعامل با امت",
      },
      {
        id: 5,
        category: "book",
        url: "/book/contemporarycrisis",
        text: "بحران های معاصر",
      },
      {
        id: 6,
        category: "book",
        url: "/book/leaders",
        text: "امرا حزب",
      },
      {
        id: 7,
        category: "book",
        url: "/book/various",
        text: "متفرقه",
      },
    ],
  },
  {
    id: 6,
    url: "/booklet",
    name: "امت بوکلت‌",
    text: "تمام بوکلت ها",
    subcatLinks: [
      {
        id: 1,
        category: "booklet",
        url: "/booklet/social",
        text: "اجتماعی",
      },
      {
        id: 2,
        category: "booklet",
        url: "/booklet/political",
        text: "سیاسی",
      },
      {
        id: 3,
        category: "booklet",
        url: "/booklet/economical",
        text: "اقتصادی",
      },
      {
        id: 4,
        category: "booklet",
        url: "/booklet/health",
        text: "صحی",
      },
      {
        id: 5,
        category: "booklet",
        url: "/booklet/islamic",
        text: "مفاهیم اسلامی",
      },
    ],
  },
  {
    id: 7,
    url: "/minibook",
    name: "مینی‌‌بوک‌",
    text: "تمام مینی بوکلت ها",
    subcatLinks: [
      {
        id: 1,
        category: "minibook",
        url: "/minibook/political",
        text: "سیاسی",
      },
      {
        id: 2,
        category: "minibook",
        url: "/minibook/health",
        text: "صحی",
      },
    ],
  },
];

export const audio = [
  {
    id: 1,
    imageSrc: "https://ummatproduction.com/media/images/2022/Tafkeer%20pic.PNG",
    subcat: "positionofht",
    subcatText: "موقف حزب التحریر",
    title: "د اونۍ خبره؛په افغانستان کې د ځینو رسنیو تخریبي رول",
    url: "http://hizb-afghanistan.com/files/audios/Rasanai_01.mp3",
    downloadLink:
      "http://ummatproduction.com/media/audio/2019/ummatproduction_Hokmeqaradad.mp3",
  },
  {
    id: 2,
    imageSrc: "https://ummatproduction.com/media/images/2022/Tafkeer%20pic.PNG",
    subcat: "qandawithamir",
    subcatText: "پرسش و پاسخ با امیر حزب التحریر",
    title: "استفاده از بیرق های سیاه و سفید در عهد خلفای راشدین",
    url: "http://hizb-afghanistan.com/files/audios/Rasanai_01.mp3",
    downloadLink:
      "http://ummatproduction.com/media/audio/2019/ummatproduction_estafada_as_Bairaqha.mp3",
  },
  {
    id: 3,
    imageSrc: "https://ummatproduction.com/media/images/2022/Tafkeer%20pic.PNG",
    subcat: "qandawithamir",
    subcatText: "پرسش و پاسخ با امیر حزب التحریر",
    title: "حکم قرارداد دوینی و نصفه گی که در افغانستان رایج است",
    url: "http://hizb-afghanistan.com/files/audios/Rasanai_01.mp3",
    downloadLink:
      "http://ummatproduction.com/media/audio/2019/ummatproduction_Hokmeqaradad.mp3",
  },
  {
    id: 4,
    imageSrc: "https://ummatproduction.com/media/images/2022/Tafkeer%20pic.PNG",
    subcat: "positionofht",
    subcatText: "موقف حزب التحریر",
    title: "د اونۍ خبره؛په افغانستان کې د ځینو رسنیو تخریبي رول",
    url: "http://hizb-afghanistan.com/files/audios/Rasanai_01.mp3",
    downloadLink:
      "http://ummatproduction.com/media/audio/2019/ummatproduction_Hokmeqaradad.mp3",
  },
  {
    id: 5,
    imageSrc: "https://ummatproduction.com/media/images/2022/Tafkeer%20pic.PNG",
    subcat: "qandawithamir",
    subcatText: "پرسش و پاسخ با امیر حزب التحریر",
    title: "استفاده از بیرق های سیاه و سفید در عهد خلفای راشدین",
    url: "http://hizb-afghanistan.com/files/audios/Rasanai_01.mp3",
    downloadLink:
      "http://ummatproduction.com/media/audio/2019/ummatproduction_estafada_as_Bairaqha.mp3",
  },
  {
    id: 6,
    imageSrc: "https://ummatproduction.com/media/images/2022/Tafkeer%20pic.PNG",
    subcat: "qandawithamir",
    subcatText: "پرسش و پاسخ با امیر حزب التحریر",
    title: "حکم قرارداد دوینی و نصفه گی که در افغانستان رایج است",
    url: "http://hizb-afghanistan.com/files/audios/Rasanai_01.mp3",
    downloadLink:
      "http://ummatproduction.com/media/audio/2019/ummatproduction_Hokmeqaradad.mp3",
  },
  {
    id: 7,
    imageSrc: "https://ummatproduction.com/media/images/2022/Tafkeer%20pic.PNG",
    subcat: "qandawithamir",
    subcatText: "پرسش و پاسخ با امیر حزب التحریر",
    title: "حکم قرارداد دوینی و نصفه گی که در افغانستان رایج است",
    url: "http://hizb-afghanistan.com/files/audios/Rasanai_01.mp3",
    downloadLink:
      "http://ummatproduction.com/media/audio/2019/ummatproduction_Hokmeqaradad.mp3",
  },
  {
    id: 8,
    imageSrc: "https://ummatproduction.com/media/images/2022/Tafkeer%20pic.PNG",
    subcat: "positionofht",
    subcatText: "موقف حزب التحریر",
    title: "د اونۍ خبره؛په افغانستان کې د ځینو رسنیو تخریبي رول",
    url: "http://hizb-afghanistan.com/files/audios/Rasanai_01.mp3",
    downloadLink:
      "http://ummatproduction.com/media/audio/2019/ummatproduction_Hokmeqaradad.mp3",
  },
  {
    id: 9,
    imageSrc: "https://ummatproduction.com/media/images/2022/Tafkeer%20pic.PNG",
    subcat: "qandawithamir",
    subcatText: "پرسش و پاسخ با امیر حزب التحریر",
    title: "استفاده از بیرق های سیاه و سفید در عهد خلفای راشدین",
    url: "http://hizb-afghanistan.com/files/audios/Rasanai_01.mp3",
    downloadLink:
      "http://ummatproduction.com/media/audio/2019/ummatproduction_estafada_as_Bairaqha.mp3",
  },
  {
    id: 10,
    imageSrc: "https://ummatproduction.com/media/images/2022/Tafkeer%20pic.PNG",
    subcat: "qandawithamir",
    subcatText: "پرسش و پاسخ با امیر حزب التحریر",
    title: "حکم قرارداد دوینی و نصفه گی که در افغانستان رایج است",
    url: "http://hizb-afghanistan.com/files/audios/Rasanai_01.mp3",
    downloadLink:
      "http://ummatproduction.com/media/audio/2019/ummatproduction_Hokmeqaradad.mp3",
  },
];

export const twoLayeredYoutubeVideo = [
  {
    id: 1,
    subcat: "ummatcapacity",
    subcatText: "ظرفیت های امت اسلامی",
    subcatVideos: [
      {
        id: 1,
        imageSrc:
          "https://i.ytimg.com/vi/xU2dKt8Eww4/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAuh_tq2G89jyhEJUYPbnq7FzoTMQ",
        title: "سلسله ظرفیت های امت اسلامی",
        subcat: "ummatcapacity",
        youttubeLink: "https://www.youtube.com/embed/xU2dKt8Eww4",
      },
      {
        id: 2,
        imageSrc:
          "https://i.ytimg.com/vi/7aeu_9E0LtQ/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAVuNCYkoyzQLqqxHs3VGawxn7pvQ",
        title:
          "ظرفیت های امت اسلامی - ظهور دوباره ی ابرقدرت - قسمت چهارم نفوس و تحصیلات",
        subcat: "ummatcapacity",
        youttubeLink: "https://www.youtube.com/embed/7aeu_9E0LtQ",
      },
      {
        id: 9,
        imageSrc:
          "https://i.ytimg.com/vi/xU2dKt8Eww4/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAuh_tq2G89jyhEJUYPbnq7FzoTMQ",
        title: "سلسله ظرفیت های امت اسلامی",
        subcat: "ummatcapacity",
        youttubeLink: "https://www.youtube.com/embed/xU2dKt8Eww4",
      },
      {
        id: 10,
        imageSrc:
          "https://i.ytimg.com/vi/7aeu_9E0LtQ/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAVuNCYkoyzQLqqxHs3VGawxn7pvQ",
        title:
          "ظرفیت های امت اسلامی - ظهور دوباره ی ابرقدرت - قسمت چهارم نفوس و تحصیلات",
        subcat: "ummatcapacity",
        youttubeLink: "https://www.youtube.com/embed/7aeu_9E0LtQ",
      },
      {
        id: 11,
        imageSrc:
          "https://i.ytimg.com/vi/7aeu_9E0LtQ/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAVuNCYkoyzQLqqxHs3VGawxn7pvQ",
        title:
          "ظرفیت های امت اسلامی - ظهور دوباره ی ابرقدرت - قسمت چهارم نفوس و تحصیلات",
        subcat: "ummatcapacity",
        youttubeLink: "https://www.youtube.com/embed/7aeu_9E0LtQ",
      },
      {
        id: 12,
        imageSrc:
          "https://i.ytimg.com/vi/xU2dKt8Eww4/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAuh_tq2G89jyhEJUYPbnq7FzoTMQ",
        title: "سلسله ظرفیت های امت اسلامی",
        subcat: "ummatcapacity",
        youttubeLink: "https://www.youtube.com/embed/xU2dKt8Eww4",
      },
      {
        id: 13,
        imageSrc:
          "https://i.ytimg.com/vi/7aeu_9E0LtQ/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAVuNCYkoyzQLqqxHs3VGawxn7pvQ",
        title:
          "ظرفیت های امت اسلامی - ظهور دوباره ی ابرقدرت - قسمت چهارم نفوس و تحصیلات",
        subcat: "ummatcapacity",
        youttubeLink: "https://www.youtube.com/embed/7aeu_9E0LtQ",
      },
    ],
  },
  {
    id: 2,
    subcat: "didyouknow",
    subcatText: "آیا میدانستید؟",
    subcatVideos: [
      {
        id: 3,
        imageSrc:
          "https://i.ytimg.com/an_webp/ZndRpzlZkQk/mqdefault_6s.webp?du=3000&sqp=COG885oG&rs=AOn4CLB3-GyaLseAOSKPtpkSrbZr0E8h9w",
        title:
          "آیا میدانستید: افغانستان ظرفیت تولید 310 هزار میگاوات برق را دارد؟!",
        subcat: "didyouknow",
        youttubeLink: "https://www.youtube.com/embed/ZndRpzlZkQk",
      },
      {
        id: 4,
        imageSrc:
          "https://i.ytimg.com/an_webp/aR9MnbkvuHQ/mqdefault_6s.webp?du=3000&sqp=CMyP85oG&rs=AOn4CLBYTUM0s94pL9ICZIDSLSBpaqDi_w",
        title: "آیا میدانستید ؟ چرا عطر فرانسه مشهور است",
        subcat: "didyouknow",
        youttubeLink: "https://www.youtube.com/embed/aR9MnbkvuHQ",
      },
    ],
  },
  {
    id: 3,
    subcat: "campaigns",
    subcatText: "کمپاین ها",
    subcatVideos: [
      {
        id: 5,
        imageSrc:
          "https://i.ytimg.com/an_webp/ZndRpzlZkQk/mqdefault_6s.webp?du=3000&sqp=COG885oG&rs=AOn4CLB3-GyaLseAOSKPtpkSrbZr0E8h9w",
        title: "کمپاین شماره یک",
        subcat: "campaigns",
        youttubeLink: "https://www.youtube.com/embed/ZndRpzlZkQk",
      },
      {
        id: 6,
        imageSrc:
          "https://i.ytimg.com/an_webp/ZndRpzlZkQk/mqdefault_6s.webp?du=3000&sqp=COG885oG&rs=AOn4CLB3-GyaLseAOSKPtpkSrbZr0E8h9w",
        title: "کمپاین شماره دو",
        subcat: "campaigns",
        youttubeLink: "https://www.youtube.com/embed/ZndRpzlZkQk",
      },
    ],
  },
  {
    id: 4,
    subcat: "various",
    subcatText: "ویدیو های متفرقه",
    subcatVideos: [
      {
        id: 7,
        imageSrc:
          "https://i.ytimg.com/an_webp/ZndRpzlZkQk/mqdefault_6s.webp?du=3000&sqp=COG885oG&rs=AOn4CLB3-GyaLseAOSKPtpkSrbZr0E8h9w",
        title: "متفرقه شماره یک",
        subcat: "various",
        youttubeLink: "https://www.youtube.com/embed/ZndRpzlZkQk",
      },
      {
        id: 8,
        imageSrc:
          "https://i.ytimg.com/an_webp/ZndRpzlZkQk/mqdefault_6s.webp?du=3000&sqp=COG885oG&rs=AOn4CLB3-GyaLseAOSKPtpkSrbZr0E8h9w",
        title: "متفرقه شماره دو",
        subcat: "various",
        youttubeLink: "https://www.youtube.com/embed/ZndRpzlZkQk",
      },
    ],
  },
];

export const generalYoutubeVideo = [
  {
    id: 1,
    imageSrc:
      "https://i.ytimg.com/vi/xU2dKt8Eww4/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAuh_tq2G89jyhEJUYPbnq7FzoTMQ",
    title: "سلسله ظرفیت های امت اسلامی",
    subcat: "ummatcapacity",
    youttubeLink: "https://www.youtube.com/embed/xU2dKt8Eww4",
  },
  {
    id: 2,
    imageSrc:
      "https://i.ytimg.com/vi/7aeu_9E0LtQ/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAVuNCYkoyzQLqqxHs3VGawxn7pvQ",
    title:
      "ظرفیت های امت اسلامی - ظهور دوباره ی ابرقدرت - قسمت چهارم نفوس و تحصیلات",
    subcat: "ummatcapacity",
    youttubeLink: "https://www.youtube.com/embed/7aeu_9E0LtQ",
  },
  {
    id: 3,
    imageSrc:
      "https://i.ytimg.com/an_webp/ZndRpzlZkQk/mqdefault_6s.webp?du=3000&sqp=COG885oG&rs=AOn4CLB3-GyaLseAOSKPtpkSrbZr0E8h9w",
    title:
      "آیا میدانستید: افغانستان ظرفیت تولید 310 هزار میگاوات برق را دارد؟!",
    subcat: "didyouknow",
    youttubeLink: "https://www.youtube.com/embed/ZndRpzlZkQk",
  },
  {
    id: 4,
    imageSrc:
      "https://i.ytimg.com/an_webp/aR9MnbkvuHQ/mqdefault_6s.webp?du=3000&sqp=CMyP85oG&rs=AOn4CLBYTUM0s94pL9ICZIDSLSBpaqDi_w",
    title: "آیا میدانستید ؟ چرا عطر فرانسه مشهور است",
    subcat: "didyouknow",
    youttubeLink: "https://www.youtube.com/embed/aR9MnbkvuHQ",
  },
  {
    id: 5,
    imageSrc:
      "https://i.ytimg.com/an_webp/ZndRpzlZkQk/mqdefault_6s.webp?du=3000&sqp=COG885oG&rs=AOn4CLB3-GyaLseAOSKPtpkSrbZr0E8h9w",
    title: "کمپاین شماره یک",
    subcat: "campaigns",
    youttubeLink: "https://www.youtube.com/embed/ZndRpzlZkQk",
  },
  {
    id: 6,
    imageSrc:
      "https://i.ytimg.com/an_webp/ZndRpzlZkQk/mqdefault_6s.webp?du=3000&sqp=COG885oG&rs=AOn4CLB3-GyaLseAOSKPtpkSrbZr0E8h9w",
    title: "کمپاین شماره دو",
    subcat: "campaigns",
    youttubeLink: "https://www.youtube.com/embed/ZndRpzlZkQk",
  },
  {
    id: 7,
    imageSrc:
      "https://i.ytimg.com/vi/xU2dKt8Eww4/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAuh_tq2G89jyhEJUYPbnq7FzoTMQ",
    title: "سلسله ظرفیت های امت اسلامی",
    subcat: "ummatcapacity",
    youttubeLink: "https://www.youtube.com/embed/xU2dKt8Eww4",
  },
  {
    id: 8,
    imageSrc:
      "https://i.ytimg.com/vi/7aeu_9E0LtQ/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAVuNCYkoyzQLqqxHs3VGawxn7pvQ",
    title:
      "ظرفیت های امت اسلامی - ظهور دوباره ی ابرقدرت - قسمت چهارم نفوس و تحصیلات",
    subcat: "ummatcapacity",
    youttubeLink: "https://www.youtube.com/embed/7aeu_9E0LtQ",
  },
  {
    id: 9,
    imageSrc:
      "https://i.ytimg.com/vi/xU2dKt8Eww4/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAuh_tq2G89jyhEJUYPbnq7FzoTMQ",
    title: "سلسله ظرفیت های امت اسلامی",
    subcat: "ummatcapacity",
    youttubeLink: "https://www.youtube.com/embed/xU2dKt8Eww4",
  },
  {
    id: 10,
    imageSrc:
      "https://i.ytimg.com/vi/7aeu_9E0LtQ/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAVuNCYkoyzQLqqxHs3VGawxn7pvQ",
    title:
      "ظرفیت های امت اسلامی - ظهور دوباره ی ابرقدرت - قسمت چهارم نفوس و تحصیلات",
    subcat: "ummatcapacity",
    youttubeLink: "https://www.youtube.com/embed/7aeu_9E0LtQ",
  },
  {
    id: 11,
    imageSrc:
      "https://i.ytimg.com/vi/xU2dKt8Eww4/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAuh_tq2G89jyhEJUYPbnq7FzoTMQ",
    title: "سلسله ظرفیت های امت اسلامی",
    subcat: "ummatcapacity",
    youttubeLink: "https://www.youtube.com/embed/xU2dKt8Eww4",
  },
  {
    id: 12,
    imageSrc:
      "https://i.ytimg.com/vi/7aeu_9E0LtQ/hqdefault.jpg?sqp=-oaymwEcCNACELwBSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAVuNCYkoyzQLqqxHs3VGawxn7pvQ",
    title:
      "ظرفیت های امت اسلامی - ظهور دوباره ی ابرقدرت - قسمت چهارم نفوس و تحصیلات",
    subcat: "ummatcapacity",
    youttubeLink: "https://www.youtube.com/embed/7aeu_9E0LtQ",
  },
];

export const bookPublication = [
  {
    id: 1,
    imageSrc:
      "https://ummatproduction.com/media/images/2022/Hamla%20Amrica.PNG",
    title: "حمله آمریکایی برای سرکوب اسلام",
    subcat: "htprogram",
    subcatText: "برنامه حزبی",
    bookLink:
      "https://ummatproduction.com/media/book/2022/2022-07-07-Hamla-e-America.pdf",
  },
  {
    id: 2,
    imageSrc: "https://www.ummatproduction.com/media/images/2019/1.jpg",
    title: "نظام اقتصادی دولت خلافت",
    subcat: "governance",
    subcatText: "دولت داری",
    bookLink:
      "https://www.ummatproduction.com/media/book/2020/bk_Nitham%20Eqtesadi_%20Dari_2017.pdf",
  },
  {
    id: 3,
    imageSrc:
      "http://ummatproduction.com/media/images/2021/Pages%20from%20Astorahayi%20Geopolitic.jpg",
    title: "اسطوره های جیوپولیتیک",
    subcat: "various",
    subcatText: "متفرقه",
    bookLink:
      "http://ummatproduction.com/media/book/2021/Astorahayi%20Geopolitic.pdf",
  },
  {
    id: 4,
    imageSrc:
      "https://www.ummatproduction.com/media/images/2022/poletical%20palosy%20pacutorssssss.png",
    title: "افکار سیاسی حزب التحریر",
    subcat: "governance",
    subcatText: "دولت داری",
    bookLink:
      "https://www.ummatproduction.com/media/book/2022/2022-07-02%20Political%20Thoughts.pdf",
  },
  {
    id: 5,
    imageSrc: "https://www.ummatproduction.com/media/images/2022/Capture.jpg",
    title: "معرفی حزب التحریر",
    subcat: "governance",
    subcatText: "دولت داری",
    bookLink:
      "https://www.ummatproduction.com/media/book/2022/2022-26-01%20Intriduction%20of%20Hizbi-%20Tahrir.pdf",
  },
  {
    id: 6,
    imageSrc: "https://ummatproduction.com/media/images/2022/Tafkeer%20pic.PNG",
    title: "تفکیر",
    subcat: "htprogram",
    subcatText: "برنامه حزبی",
    bookLink:
      "https://ummatproduction.com/media/book/2022/2022-07-06_Tafkeer.pdf",
  },
  {
    id: 7,
    imageSrc:
      "http://ummatproduction.com/media/images/2021/Pages%20from%20Jangi%20Farhangha.jpg",
    title: "برخورد فرهنگ ها",
    subcat: "htprogram",
    subcatText: "برنامه حزبی",
    bookLink:
      "http://ummatproduction.com/media/book/2021/Jangi%20Farhangha.pdf",
  },
  {
    id: 8,
    imageSrc:
      "https://ummatproduction.com/media/images/2021/Pages%20from%20Chegonagi_warood_ba_Jamiaa.jpg",
    title: "چگونگی ورود به جامعه",
    subcat: "globalactivity",
    subcatText: "فعالیت های جهانی",
    bookLink:
      "https://ummatproduction.com/media/book/2021/Chegonagi_warood_ba_Jamiaa.pdf",
  },
  {
    id: 9,
    imageSrc:
      "https://www.ummatproduction.com/media/images/2021/maf%20kora%20tasavi%20zan%20and%20mard%20dari%2012.PNG",
    title: "مفکوره تساوی مرد و زن و دیدگاه اسلام",
    subcat: "interactingwithummat",
    subcatText: "تعامل با امت",
    bookLink:
      "https://ummatproduction.com/media/book/2021/Chegonagi_warood_ba_Jamiaa.pdf",
  },
  {
    id: 10,
    imageSrc:
      "https://ummatproduction.com/media/images/2021/Pages%20from%20Wajeeb_Ummat.jpg",
    title: "واجب امت",
    subcat: "various",
    subcatText: "متفرقه",
    bookLink:
      "https://ummatproduction.com/media/book/2021/Chegonagi_warood_ba_Jamiaa.pdf",
  },
  {
    id: 11,
    imageSrc:
      "https://www.ummatproduction.com/media/images/2021/maf%20kora%20tasavi%20zan%20and%20mard%20dari%2012.PNG",
    title: "مفکوره تساوی مرد و زن و دیدگاه اسلام",
    subcat: "interactingwithummat",
    subcatText: "تعامل با امت",
    bookLink:
      "https://ummatproduction.com/media/book/2021/Chegonagi_warood_ba_Jamiaa.pdf",
  },
  {
    id: 12,
    imageSrc:
      "https://ummatproduction.com/media/images/2021/Pages%20from%20Wajeeb_Ummat.jpg",
    title: "واجب امت",
    subcat: "various",
    subcatText: "متفرقه",
    bookLink:
      "https://ummatproduction.com/media/book/2021/Chegonagi_warood_ba_Jamiaa.pdf",
  },
  {
    id: 13,
    imageSrc:
      "https://ummatproduction.com/media/images/2021/Pages%20from%20Wajeeb_Ummat.jpg",
    title: "واجب امت",
    subcat: "various",
    subcatText: "متفرقه",
    bookLink:
      "https://ummatproduction.com/media/book/2021/Chegonagi_warood_ba_Jamiaa.pdf",
  },
  {
    id: 14,
    imageSrc:
      "https://www.ummatproduction.com/media/images/2021/maf%20kora%20tasavi%20zan%20and%20mard%20dari%2012.PNG",
    title: "مفکوره تساوی مرد و زن و دیدگاه اسلام",
    subcat: "interactingwithummat",
    subcatText: "تعامل با امت",
    bookLink:
      "https://ummatproduction.com/media/book/2021/Chegonagi_warood_ba_Jamiaa.pdf",
  },
  {
    id: 15,
    imageSrc:
      "https://ummatproduction.com/media/images/2021/Pages%20from%20Wajeeb_Ummat.jpg",
    title: "واجب امت",
    subcat: "various",
    subcatText: "متفرقه",
    bookLink:
      "https://ummatproduction.com/media/book/2021/Chegonagi_warood_ba_Jamiaa.pdf",
  },
];

export const magazinePublication = [
  {
    id: 1,
    imageSrc:
      "http://ummatproduction.com/media/images/2019/khalafat%20magazin%2012.JPG",
    title: "مجله خلافت شماره 12",
    subcat: "khilafahmagazine",
    subcatText: "مجله خلافت",
    magazineLink:
      "http://ummatproduction.com/media/magazin/2019/Khilafat%20Magazine%20Issue_12.pdf",
  },
  {
    id: 2,
    imageSrc:
      "http://ummatproduction.com/media/images/2019/khalafat%20magzin%2013.JPG",
    title: "مجله خلافت شماره 13 مجله خلافت شماره 13 مجله خلافت شماره 13",
    subcat: "khilafahmagazine",
    subcatText: "مجله خلافت",
    magazineLink:
      "http://ummatproduction.com/media/magazin/2019/Khilafat%20Magazine%20Issue_13.pdf",
  },
  {
    id: 3,
    imageSrc: "http://ummatproduction.com/media/images/2019/111q.JPG",
    title: "قیام شماره یک",
    subcat: "qeyam",
    subcatText: "رساله قیام",
    magazineLink:
      "http://ummatproduction.com/media/magazin/2019/Khilafat%20Magazine%20Issue_12.pdf",
  },
  {
    id: 4,
    imageSrc: "http://ummatproduction.com/media/images/2019/222q.JPG",
    title: "قیام شماره دو",
    subcat: "qeyam",
    subcatText: "رساله قیام",
    magazineLink:
      "http://ummatproduction.com/media/magazin/2019/Khilafat%20Magazine%20Issue_13.pdf",
  },
  {
    id: 5,
    imageSrc: "http://www.ummatproduction.com/media/images/2019/13t.JPG",
    title: "رساله تغییر شماره سه",
    subcat: "taghir",
    subcatText: "رساله تغییر",
    magazineLink:
      "http://ummatproduction.com/media/magazin/2019/Khilafat%20Magazine%20Issue_12.pdf",
  },
  {
    id: 6,
    imageSrc: "http://ummatproduction.com/media/images/2019/222q.JPG",
    title: "رساله تغییر شماره دو",
    subcat: "taghir",
    subcatText: "رساله تغییر",
    magazineLink:
      "http://ummatproduction.com/media/magazin/2019/Khilafat%20Magazine%20Issue_13.pdf",
  },
];

export const bookletPublication = [
  {
    id: 1,
    imageSrc:
      "https://ummatproduction.com/media/images/2022/fasadi%20wizha.PNG",
    title: "ویژه فساد اجتماعی نظام سرمایه داری",
    subcat: "social",
    subcatText: "اجتماعی",
    bookletLink:
      "https://ummatproduction.com/media/magazin/2022/Wizha%20Fasad%20Ejtimee.pdf",
  },
  {
    id: 2,
    imageSrc:
      "https://ummatproduction.com/media/images/2022/Islam%20afghani%20ya%20jahani.PNG",
    title: "اسلام افغانی یا جهانی",
    subcat: "political",
    subcatText: "سیاسی",
    bookletLink:
      "https://ummatproduction.com/media/magazin/2022/Islaam%20afghani%20ya%20jahni.pdf",
  },
  {
    id: 3,
    imageSrc:
      "https://ummatproduction.com/media/images/2022/Hoqoqi%20Bashar.PNG",
    title: "حقوق بشر مار زیبا اما کشنده",
    subcat: "political",
    subcatText: "سیاسی",
    bookletLink:
      "https://ummatproduction.com/media/magazin/2022/Hoqoqi%20Bashar.pdf",
  },
  {
    id: 5,
    imageSrc: "http://ummatproduction.com/media/images/2022/crona.PNG",
    title: "نگاه متفاوت به ویروس کرونا",
    subcat: "health",
    subcatText: "صحی",
    bookletLink: "http://ummatproduction.com/media/magazin/2022/Crona.pdf",
  },
  {
    id: 6,
    imageSrc:
      "https://ummatproduction.com/media/images/2022/wizha%20fasadi%20sehee.PNG",
    title: "ویژه فساد صحی نظام سرمایه داری",
    subcat: "health",
    subcatText: "صحی",
    bookletLink:
      "https://ummatproduction.com/media/magazin/2022/Wizha%20fasadi%20sehee.pdf",
  },
  {
    id: 7,
    imageSrc: "http://ummatproduction.com/media/images/2022/Sura%20Fatiha.PNG",
    title: "فهم سوره فاتحه",
    subcat: "islamic",
    subcatText: "مفاهیم اسلامی",
    bookletLink:
      "http://ummatproduction.com/media/magazin/2022/Sura%20Fatiha.pdf",
  },
  {
    id: 8,
    imageSrc: "http://ummatproduction.com/media/images/2022/sirat.PNG",
    title: "از مکه تا مدینه روش تغییر جامعه",
    subcat: "islamic",
    subcatText: "مفاهیم اسلامی",
    bookletLink: "http://ummatproduction.com/media/magazin/2022/sirat.pdf",
  },
];

export const minibookPublication = [
  {
    id: 1,
    imageSrc:
      "https://ummatproduction.com/media/images/2022/fasadi%20wizha.PNG",
    title: "ویژه فساد اجتماعی نظام سرمایه داری",
    subcat: "social",
    subcatText: "اجتماعی",
    minibookLink:
      "https://ummatproduction.com/media/magazin/2022/Wizha%20Fasad%20Ejtimee.pdf",
  },
  {
    id: 2,
    imageSrc:
      "https://ummatproduction.com/media/images/2022/Islam%20afghani%20ya%20jahani.PNG",
    title: "اسلام افغانی یا جهانی",
    subcat: "political",
    subcatText: "سیاسی",
    minibookLink:
      "https://ummatproduction.com/media/magazin/2022/Islaam%20afghani%20ya%20jahni.pdf",
  },
  {
    id: 3,
    imageSrc:
      "https://ummatproduction.com/media/images/2022/Hoqoqi%20Bashar.PNG",
    title: "حقوق بشر مار زیبا اما کشنده",
    subcat: "political",
    subcatText: "سیاسی",
    minibookLink:
      "https://ummatproduction.com/media/magazin/2022/Hoqoqi%20Bashar.pdf",
  },
  {
    id: 5,
    imageSrc: "http://ummatproduction.com/media/images/2022/crona.PNG",
    title: "نگاه متفاوت به ویروس کرونا",
    subcat: "health",
    subcatText: "صحی",
    minibookLink: "http://ummatproduction.com/media/magazin/2022/Crona.pdf",
  },
  {
    id: 6,
    imageSrc:
      "https://ummatproduction.com/media/images/2022/wizha%20fasadi%20sehee.PNG",
    title: "ویژه فساد صحی نظام سرمایه داری",
    subcat: "health",
    subcatText: "صحی",
    minibookLink:
      "https://ummatproduction.com/media/magazin/2022/Wizha%20fasadi%20sehee.pdf",
  },
  {
    id: 7,
    imageSrc: "http://ummatproduction.com/media/images/2022/Sura%20Fatiha.PNG",
    title: "فهم سوره فاتحه",
    subcat: "islamic",
    subcatText: "مفاهیم اسلامی",
    minibookLink:
      "http://ummatproduction.com/media/magazin/2022/Sura%20Fatiha.pdf",
  },
  {
    id: 8,
    imageSrc: "http://ummatproduction.com/media/images/2022/sirat.PNG",
    title: "از مکه تا مدینه روش تغییر جامعه",
    subcat: "islamic",
    subcatText: "مفاهیم اسلامی",
    minibookLink: "http://ummatproduction.com/media/magazin/2022/sirat.pdf",
  },
];

export const latestPublication = [
  {
    id: 1,
    imageSrc:
      "https://ummatproduction.com/media/images/2022/Hamla%20Amrica.PNG",
    title: "حمله آمریکایی برای سرکوب اسلام",
    subcat: "htprogram",
    category: "book",
  },
  {
    id: 2,
    imageSrc: "https://www.ummatproduction.com/media/images/2019/1.jpg",
    title: "نظام اقتصادی دولت خلافت",
    subcat: "governance",
    category: "book",
  },
  {
    id: 3,
    imageSrc:
      "http://ummatproduction.com/media/images/2021/Pages%20from%20Astorahayi%20Geopolitic.jpg",
    title: "اسطوره های جیوپولیتیک",
    subcat: "various",
    category: "book",
  },
  {
    id: 4,
    imageSrc:
      "https://www.ummatproduction.com/media/images/2021/ummat_magazaine_5th%20p.jpg",
    title: "صد سال پس از سقوط خلافت",
    subcat: "ummat",
    category: "magazine",
  },
  {
    id: 5,
    imageSrc:
      "http://ummatproduction.com/media/images/2019/final%20second%20magazine.PNG",
    title: "دولت ملت",
    subcat: "ummat",
    category: "magazine",
  },
  {
    id: 6,
    imageSrc: "http://ummatproduction.com/media/images/2019/ummatmagzine1.PNG",
    title: "سندروم استاکهلم",
    subcat: "ummat",
    category: "magazine",
  },
  {
    id: 7,
    imageSrc: "http://ummatproduction.com/media/images/2022/crona.PNG",
    title: "نگاه متفاوت به ویروس کرونا",
    subcat: "health",
    category: "booklet",
  },
  {
    id: 8,
    imageSrc:
      "https://ummatproduction.com/media/images/2022/Islam%20afghani%20ya%20jahani.PNG",
    title: "اسلام افغانی یا جهانی",
    subcat: "political",
    category: "booklet",
  },
  {
    id: 9,
    imageSrc: "http://ummatproduction.com/media/images/2022/Crona2.PNG",
    title: "رفع سوء تفامات پیرامون ویروس کرونا",
    subcat: "health",
    category: "booklet",
  },
];

export const footerLinks = [
  {
    id: 1,
    url: "/booklet",
    name: "امت بوکلت",
    text: "تمام بوکلت ها",
    subcatLinks: [
      {
        id: 1,
        category: "booklet",
        url: "/booklet/social",
        text: "اجتماعی",
      },
      {
        id: 2,
        category: "booklet",
        url: "/booklet/political",
        text: "سیاسی",
      },
      {
        id: 3,
        category: "booklet",
        url: "/booklet/economical",
        text: "اقتصادی",
      },
      {
        id: 4,
        category: "booklet",
        url: "/booklet/health",
        text: "صحی",
      },
      {
        id: 5,
        category: "booklet",
        url: "/booklet/islamic",
        text: "مفاهیم اسلامی",
      },
    ],
  },
  {
    id: 2,
    url: "/audio",
    name: "امت صوتی",
    text: "تمام صوتی ها",
    subcatLinks: [
      {
        id: 1,
        category: "audio",
        url: "/audio/positionofht",
        text: "موقف حزب التحریر",
      },
      {
        id: 2,
        category: "audio",
        url: "/audio/towardslight",
        text: "بسوی روشنایی",
      },
      {
        id: 3,
        category: "audio",
        url: "/audio/tafsir",
        text: "سلسله درسهای تفسیر",
      },
      {
        id: 4,
        category: "audio",
        url: "/audio/qandawithamir",
        text: "پرسش و پاسخ با امیر حزب التحریر",
      },
      {
        id: 5,
        category: "audio",
        url: "/audio/sirat",
        text: "بخش سیرت",
      },
    ],
  },

  {
    id: 3,
    url: "/magazine",
    name: "امت مجله",
    text: "تمام مجلات",
    subcatLinks: [
      {
        id: 1,
        category: "magazine",
        url: "/magazine/khilafahmagazine",
        text: "مجله خلافت",
      },
      {
        id: 2,
        category: "magazine",
        url: "/magazine/qeyam",
        text: "رساله قیام",
      },
      {
        id: 3,
        category: "magazine",
        url: "/magazine/taghir",
        text: "رساله تغییر",
      },
      {
        id: 4,
        category: "magazine",
        url: "/magazine/khilafahgahnama",
        text: "گاهنامه خلافت",
      },
      {
        id: 5,
        category: "magazine",
        url: "/magazine/ummat",
        text: "مجله امت",
      },
      {
        id: 6,
        category: "magazine",
        url: "/magazine/bookletandbrochure",
        text: "بوکلت و بروشور",
      },
    ],
  },

  {
    id: 4,
    url: "/book",
    name: "امت کتاب",
    text: "تمام کتب",
    subcatLinks: [
      {
        id: 1,
        category: "book",
        url: "/book/governance",
        text: "دولت داری",
      },
      {
        id: 2,
        category: "book",
        url: "/book/htprogram",
        text: "برنامه حزبی",
      },
      {
        id: 3,
        category: "book",
        url: "/book/globalactivity",
        text: "فعالیت های جهانی",
      },
      {
        id: 4,
        category: "book",
        url: "/book/interactingwithummat",
        text: "تعامل با امت",
      },
      {
        id: 5,
        category: "book",
        url: "/book/contemporarycrises",
        text: "بحران های معاصر",
      },
      {
        id: 6,
        category: "book",
        url: "/book/leaders",
        text: "امرا حزب",
      },
      {
        id: 7,
        category: "book",
        url: "/book/various",
        text: "متفرفه",
      },
    ],
  },
  {
    id: 5,
    url: "/news",
    name: "امت نیوز",
    text: "تمام اخبار",
    subcatLinks: [
      {
        id: 1,
        category: "news",
        url: "/news/articles",
        text: "مقالات",
      },
      {
        id: 2,
        category: "news",
        url: "/news/infographic",
        text: "انفوگرافیک",
      },
      {
        id: 3,
        category: "news",
        url: "/news/videos",
        text: "ویدیو ها",
      },
    ],
  },
  {
    id: 6,
    url: "/video",
    name: "امت ویدیو",
    text: "تمام ویدیوها",
    subcatLinks: [
      {
        id: 1,
        category: "video",
        url: "/video/ummatcapacity",
        text: "ظرفیت های امت اسلامی",
      },
      {
        id: 2,
        category: "video",
        url: "/video/didyouknow",
        text: "آیا میدانستید؟",
      },
      {
        id: 3,
        category: "video",
        url: "/video/campaigns",
        text: "کمپاین ها",
      },
      {
        id: 4,
        category: "video",
        url: "/video/various",
        text: "ویدیو های متفرقه",
      },
    ],
  },
];

export const newsData = [
  {
    id: 1,
    title: "از فرض ما تا نیاز ما",
    date: "22 sep 2022",
    imageSrc:
      "http://ummatproduction.com/media/images/2019/photo_2020-10-17_10-34-39.jpg",
    shortDesc:
      "امام شخصی است که دیگران از وی پیروی می‌کند، خواه در راس حکومت باشد و خواه یک پیش نماز ساده که مردم پشت سر او می‌ایستند. امام کسی است که با اقتدا به وی مراسم نماز را به جا می‌آورند و برخی امام را مترادف با هادی و راهنما می‌دانند؛ یعنی کسی‌که مردم را بسوی هدف هدایت می‌کند. در فرهنگ دینی ما کسی‌که امت را بسوی رستگاری دنیا و آخرت رهنمون می‌سازد، امام و پیشوا است.",
    longDesc:
      "<p>امام شخصی است که دیگران از وی پیروی می‌کند، خواه در راس حکومت باشد و خواه یک پیش نماز ساده که مردم پشت سر او می‌ایستند. امام کسی است که با اقتدا به وی مراسم نماز را به جا می‌آورند و برخی امام را مترادف با هادی و راهنما می‌دانند؛ یعنی کسی‌که مردم را بسوی هدف هدایت می‌کند. در فرهنگ دینی ما کسی‌که امت را بسوی رستگاری دنیا و آخرت رهنمون می‌سازد، امام و پیشوا است.</p><p>حالا در ذهن خود تصویر‌ی ایجاد کنید؛ در جماعتی هستید که قصد ادای نماز دارید ولی شخصی نیست که امام جماعت شود و ادای نماز کند. پس این وضعیت وحشتناک خواهد بود؛ زمانی‌که امامی وجود نداشته باشد که پیش نماز شود و مردم در زیر سقف یک مسجد بصورت متفرق و جداگانه ادای نماز کنند! یقیناً که چنین وضعیتی برای یک مومن وحشتناک خواهد بود.</p><p>برای درک بهتر این مطلب جامعه و امت اسلامی را کاروانی در حال حرکت در نظر آوریم که می‌خواهند از جاده‌ی پر خطر زندگی عبور کنند و بسوی آخرت قدم نهند. ما مسلمانان را عقیده چنین است که زندگی همچون سفری در بیابان‌های خطرناک و کشنده‌ای است که در آن هر مسافری به آسانی در معرض آن قرار دارد که به بیراهه برود و هلاک شود. هر مسافر برای اینکه به سلامت برود ناگزیر است در بیابان پر خطر خود را زیر چتر هدایت یک هادی(رهنما) قرار دهد که عقلاً چنین استدلالی و راه حلی قابل قبول است.</p><p>از همان آغاز نسل بشر تا کنون هر قومی را و هر ملتی را پیشوا و رهبری بوده برای هدایت و در امان بودن از دست دشمن. هیچ ملتی بدون یک کار فهم و کاردان که در راس قرار دارد، به فلاح نخواهد رسید.</p><p>اسلام هم از همان آغاز به کارآیی و مهم بودن امام(خلیفه) در جماعت بشر تاکید داشته و آن را یک فرض به گردن مسلمانان نهاده است که تشکیل دولت توسط پیامبر اسلام صلی الله علیه وسلم در مدینه خود برهانی است بر موضوع.</p><p>پس، آیا زیبنده است امتی که برترین امت‌هاست بدون امام(خلیفه) باشد؟ ما مسلمانان را نیاز اساسی و مبرم برای تأسیس دوباره‌ی دولت واحد خلافت و بیعت کردن با امامی که تمام فکر و ذهنش خدمت به امت و کسب رضایت الله باشد؛ تا باشد که خود را از بلاهای دنیوی و اخروی رهایی بخشیم. زیرا پیامبر اسلام صلی الله علیه وسلم می‌فرمایند: هر کس بدون امام(خلیفه) بمیرد؛ به مرگ جاهلیت مرده است.</p><p>پس از فرض ما تا نیاز ما همه بیعت به امام است.</p>",
    subcat: "articles",
  },
  {
    id: 2,
    title: "سیر از شکم گرسنه چه خبر",
    date: "22 sep 2022",
    imageSrc:
      "http://ummatproduction.com/media/images/2019/photo_2020-10-17_10-34-53.jpg",
    shortDesc:
      "امام شخصی است که دیگران از وی پیروی می‌کند، خواه در راس حکومت باشد و خواه یک پیش نماز ساده که مردم پشت سر او می‌ایستند. امام کسی است که با اقتدا به وی مراسم نماز را به جا می‌آورند و برخی امام را مترادف با هادی و راهنما می‌دانند؛ یعنی کسی‌که مردم را بسوی هدف هدایت می‌کند. در فرهنگ دینی ما کسی‌که امت را بسوی رستگاری دنیا و آخرت رهنمون می‌سازد، امام و پیشوا است.",
    longDesc:
      "<p>امام شخصی است که دیگران از وی پیروی می‌کند، خواه در راس حکومت باشد و خواه یک پیش نماز ساده که مردم پشت سر او می‌ایستند. امام کسی است که با اقتدا به وی مراسم نماز را به جا می‌آورند و برخی امام را مترادف با هادی و راهنما می‌دانند؛ یعنی کسی‌که مردم را بسوی هدف هدایت می‌کند. در فرهنگ دینی ما کسی‌که امت را بسوی رستگاری دنیا و آخرت رهنمون می‌سازد، امام و پیشوا است.</p><p>حالا در ذهن خود تصویر‌ی ایجاد کنید؛ در جماعتی هستید که قصد ادای نماز دارید ولی شخصی نیست که امام جماعت شود و ادای نماز کند. پس این وضعیت وحشتناک خواهد بود؛ زمانی‌که امامی وجود نداشته باشد که پیش نماز شود و مردم در زیر سقف یک مسجد بصورت متفرق و جداگانه ادای نماز کنند! یقیناً که چنین وضعیتی برای یک مومن وحشتناک خواهد بود.</p><p>برای درک بهتر این مطلب جامعه و امت اسلامی را کاروانی در حال حرکت در نظر آوریم که می‌خواهند از جاده‌ی پر خطر زندگی عبور کنند و بسوی آخرت قدم نهند. ما مسلمانان را عقیده چنین است که زندگی همچون سفری در بیابان‌های خطرناک و کشنده‌ای است که در آن هر مسافری به آسانی در معرض آن قرار دارد که به بیراهه برود و هلاک شود. هر مسافر برای اینکه به سلامت برود ناگزیر است در بیابان پر خطر خود را زیر چتر هدایت یک هادی(رهنما) قرار دهد که عقلاً چنین استدلالی و راه حلی قابل قبول است.</p><p>از همان آغاز نسل بشر تا کنون هر قومی را و هر ملتی را پیشوا و رهبری بوده برای هدایت و در امان بودن از دست دشمن. هیچ ملتی بدون یک کار فهم و کاردان که در راس قرار دارد، به فلاح نخواهد رسید.</p><p>اسلام هم از همان آغاز به کارآیی و مهم بودن امام(خلیفه) در جماعت بشر تاکید داشته و آن را یک فرض به گردن مسلمانان نهاده است که تشکیل دولت توسط پیامبر اسلام صلی الله علیه وسلم در مدینه خود برهانی است بر موضوع.</p><p>پس، آیا زیبنده است امتی که برترین امت‌هاست بدون امام(خلیفه) باشد؟ ما مسلمانان را نیاز اساسی و مبرم برای تأسیس دوباره‌ی دولت واحد خلافت و بیعت کردن با امامی که تمام فکر و ذهنش خدمت به امت و کسب رضایت الله باشد؛ تا باشد که خود را از بلاهای دنیوی و اخروی رهایی بخشیم. زیرا پیامبر اسلام صلی الله علیه وسلم می‌فرمایند: هر کس بدون امام(خلیفه) بمیرد؛ به مرگ جاهلیت مرده است.</p><p>پس از فرض ما تا نیاز ما همه بیعت به امام است.</p>",
    subcat: "articles",
  },
  {
    id: 3,
    title: "کانکور مسیری اشتباه بسوی دانش",
    date: "22 sep 2022",
    imageSrc:
      "http://ummatproduction.com/media/images/2019/photo_2020-10-17_10-14-37.jpg",
    shortDesc:
      "امام شخصی است که دیگران از وی پیروی می‌کند، خواه در راس حکومت باشد و خواه یک پیش نماز ساده که مردم پشت سر او می‌ایستند. امام کسی است که با اقتدا به وی مراسم نماز را به جا می‌آورند و برخی امام را مترادف با هادی و راهنما می‌دانند؛ یعنی کسی‌که مردم را بسوی هدف هدایت می‌کند. در فرهنگ دینی ما کسی‌که امت را بسوی رستگاری دنیا و آخرت رهنمون می‌سازد، امام و پیشوا است.",
    longDesc:
      "<p>امام شخصی است که دیگران از وی پیروی می‌کند، خواه در راس حکومت باشد و خواه یک پیش نماز ساده که مردم پشت سر او می‌ایستند. امام کسی است که با اقتدا به وی مراسم نماز را به جا می‌آورند و برخی امام را مترادف با هادی و راهنما می‌دانند؛ یعنی کسی‌که مردم را بسوی هدف هدایت می‌کند. در فرهنگ دینی ما کسی‌که امت را بسوی رستگاری دنیا و آخرت رهنمون می‌سازد، امام و پیشوا است.</p><p>حالا در ذهن خود تصویر‌ی ایجاد کنید؛ در جماعتی هستید که قصد ادای نماز دارید ولی شخصی نیست که امام جماعت شود و ادای نماز کند. پس این وضعیت وحشتناک خواهد بود؛ زمانی‌که امامی وجود نداشته باشد که پیش نماز شود و مردم در زیر سقف یک مسجد بصورت متفرق و جداگانه ادای نماز کنند! یقیناً که چنین وضعیتی برای یک مومن وحشتناک خواهد بود.</p><p>برای درک بهتر این مطلب جامعه و امت اسلامی را کاروانی در حال حرکت در نظر آوریم که می‌خواهند از جاده‌ی پر خطر زندگی عبور کنند و بسوی آخرت قدم نهند. ما مسلمانان را عقیده چنین است که زندگی همچون سفری در بیابان‌های خطرناک و کشنده‌ای است که در آن هر مسافری به آسانی در معرض آن قرار دارد که به بیراهه برود و هلاک شود. هر مسافر برای اینکه به سلامت برود ناگزیر است در بیابان پر خطر خود را زیر چتر هدایت یک هادی(رهنما) قرار دهد که عقلاً چنین استدلالی و راه حلی قابل قبول است.</p><p>از همان آغاز نسل بشر تا کنون هر قومی را و هر ملتی را پیشوا و رهبری بوده برای هدایت و در امان بودن از دست دشمن. هیچ ملتی بدون یک کار فهم و کاردان که در راس قرار دارد، به فلاح نخواهد رسید.</p><p>اسلام هم از همان آغاز به کارآیی و مهم بودن امام(خلیفه) در جماعت بشر تاکید داشته و آن را یک فرض به گردن مسلمانان نهاده است که تشکیل دولت توسط پیامبر اسلام صلی الله علیه وسلم در مدینه خود برهانی است بر موضوع.</p><p>پس، آیا زیبنده است امتی که برترین امت‌هاست بدون امام(خلیفه) باشد؟ ما مسلمانان را نیاز اساسی و مبرم برای تأسیس دوباره‌ی دولت واحد خلافت و بیعت کردن با امامی که تمام فکر و ذهنش خدمت به امت و کسب رضایت الله باشد؛ تا باشد که خود را از بلاهای دنیوی و اخروی رهایی بخشیم. زیرا پیامبر اسلام صلی الله علیه وسلم می‌فرمایند: هر کس بدون امام(خلیفه) بمیرد؛ به مرگ جاهلیت مرده است.</p><p>پس از فرض ما تا نیاز ما همه بیعت به امام است.</p>",
    subcat: "articles",
  },
];

export const responsive = {
  extralarge: {
    breakpoint: { max: 3000, min: 1440 },
    items: 4.5,
    slidesToSlide: 3, // optional, default to 1.
  },
  desktop: {
    breakpoint: { max: 1440, min: 800 },
    items: 3.5,
    slidesToSlide: 3, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 800, min: 464 },
    items: 2,
    slidesToSlide: 2, // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1.1,
    slidesToSlide: 1, // optional, default to 1.
  },
};
